exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[data-v-31602b3a]{scroll-behavior:smooth}.question[data-v-31602b3a]{font-size:13px}", ""]);

// exports
